module.exports = __webpack_public_path__ + "static/img/4636_phase_function_Paper_PointsHejduk_Prediction.a734c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4636_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 9hsw
// module chunks = 0